import React from 'react';
import PDF from 'react-pdf-js-infinite';

export default class PDFComponent extends React.Component {
    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        const element = document.querySelector('.pdf-wrapper > div');
        if (element) {
            element.addEventListener('scroll', this.handleScroll);
        }
    }

    componentWillUnmount() {
        const element = document.querySelector('.pdf-wrapper > div');
        if (element) {
            element.removeEventListener('scroll', this.handleScroll);
        }
    }

    handleScroll(e) {
        if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
            this.props.handleScrollToBottom();
        }
    }

    render() {
        return (<PDF file ={this.props.file} scale={1.5}/>);
    }
}
